// ── PmtPostingRuleForm (wfloanmatchrules) ──
import { B } from "../../../shared/theme";
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const PmtPostingRuleForm = ({ initial, readOnly }) => {
  const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
  const [f, set] = useFreshForm(initial || {
    pattern: "", loanid: "", priority: "", isactive: "1", notes: ""
  }, "wfloanmatchrules");

  const ACTIVE_OPTIONS = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ];

  const ST = ({ title }) => <div style={{ gridColumn: "1/-1", fontSize: 11, fontWeight: 600, color: B.cyanDark, textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 18, marginBottom: 8, paddingBottom: 4, borderBottom: "1.5px solid " + B.cyanLight }}>{title}</div>;

  // isactive may arrive from SQL as true/false/1/0 — normalize to "1"/"0" for the select
  const activeVal = (f.isactive === true || f.isactive === 1 || f.isactive === "1") ? "1" : "0";

  return <Modal title={readOnly ? "View Posting Rule" : initial ? "Edit Posting Rule" : "Add Posting Rule"} onClose={closeModal}
    onEdit={readOnly && role.canEdit ? () => { closeModal(); setModal({ type: "pmtpostingrule-edit", rec: initial, onDone: modal.onDone }); } : null}>
    <ReadOnlyForm readOnly={readOnly}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 24px" }}>
        <ST title="Rule" />
        <Field label="Pattern"><FInput value={f.pattern || ""} onChange={set("pattern")} placeholder="e.g. ACME*" /></Field>
        <Field label="Loan ID"><FInput value={f.loanid || ""} onChange={set("loanid")} placeholder="e.g. LN123..." /></Field>
        <Field label="Priority (lower runs first)"><FInput type="number" step="1" value={f.priority} onChange={set("priority")} /></Field>
        <Field label="Status"><FSelect value={activeVal} onChange={set("isactive")} options={ACTIVE_OPTIONS} /></Field>
        <Field label="Notes" style={{ gridColumn: "1/-1" }}><FInput value={f.notes || ""} onChange={set("notes")} /></Field>
      </div>
    </ReadOnlyForm>
    {!readOnly && error && <div style={{ color: "#993C1D", fontSize: 12, marginBottom: 8, marginTop: 8 }}>{error}</div>}
    <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
      <Btn onClick={closeModal}>{readOnly ? "Close" : "Cancel"}</Btn>
      {!readOnly && <Btn disabled={saving} onClick={() => saveRec("savePmtPostingRule", { ...f, isactive: activeVal }, initial ? "Edited" : "Added", "wfloanmatchrules", (initial ? "Updated" : "Added") + " payment posting rule", modal.onDone)} variant="primary">{saving ? "Saving..." : "Save"}</Btn>}
    </div>
  </Modal>;
};
